import type { UIMessage } from 'ai';
import { RefObject, useEffect, useRef } from 'react';

export const useChatScroll = (
  messages: UIMessage[],
): RefObject<HTMLDivElement> => {
  const containerRef = useRef<HTMLDivElement>(null);
  const lastSignatureRef = useRef('');

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const last = messages[messages.length - 1];
    const lastTextLength = last
      ? last.parts.reduce(
          (acc, part) => acc + (part.type === 'text' ? part.text.length : 0),
          0,
        )
      : 0;
    const signature = `${messages.length}:${last?.id ?? ''}:${lastTextLength}`;
    if (signature === lastSignatureRef.current) return;
    lastSignatureRef.current = signature;

    const distanceFromBottom =
      container.scrollHeight - container.scrollTop - container.clientHeight;
    const isPinnedToBottom = distanceFromBottom < 80;
    if (isPinnedToBottom) {
      container.scrollTop = container.scrollHeight;
    }
  }, [messages]);

  return containerRef;
};
